<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "AuctionItem" });
import * as API from "../../services/api.js";
import { AUCTION_STORE } from "../../services/store.js";
export let key;
export let onError = void 0;
const fetchAuction = (key2) => {
    if (key2 === void 0) {
        return;
    }
    void API.fetchAuction({ auctionKey: key2 }, onError);
};
$: fetchAuction(key);
</script>

{#if key !== undefined && key in $AUCTION_STORE }

    <slot auction = { $AUCTION_STORE[key] }>

        <pre>{ JSON.stringify($AUCTION_STORE[key], null, 4) }</pre>

    </slot>

{/if}